import AddIcon from 'components/ReusableComponents/Icons/Add'
import { CheckIcon } from 'components/ReusableComponents/Icons/Check'
import RemoveIcon from 'components/ReusableComponents/Icons/Remove'
import { behaviorNames } from 'main/blacklistHelpers'
import PropTypes from 'prop-types'

import styles from './RateCodeRow.module.scss'

const actions = {
  add: 'add',
  added: 'added',
  remove: 'remove'
}

function getBlacklistBehavior(str) {
  return behaviorNames[str.charAt(0).toLowerCase() + str.slice(1)]
}

const RateCodeRow = ({
  rateCode,
  action = actions.add,
  count,
  onClick,
  disabled,
  exclusionInfo
}) => {
  return (
    <>
      <div
        className={[
          styles.wrapper,
          action === actions.added ? styles.wrapperAdded : ''
        ].join(' ')}
        onClick={disabled ? null : onClick}
        data-tip={exclusionInfo ? getBlacklistBehavior(exclusionInfo.behavior) : null}
        data-for="rateCodeRow"
      >
        <div className={disabled ? styles.containerDisabled : styles.container}>
          <div className={styles.actionIcon}>
            {action === actions.add && <AddIcon width={28} height={28} fill="#4079F5" />}
            {action === actions.remove && (
              <RemoveIcon width={28} height={28} fill="#D5C5C5" />
            )}
            {action === actions.added && <CheckIcon width={18} height={18} />}
          </div>
          <span className={styles.rateCode}>{rateCode}</span>
          <span className={styles.count}>{count}</span>
        </div>
      </div>
    </>
  )
}

RateCodeRow.propTypes = {
  action: PropTypes.oneOf(Object.values(actions)),
  rateCode: PropTypes.string,
  count: PropTypes.oneOfType(PropTypes.number, PropTypes.string)
}

export default RateCodeRow
